import { Component } from 'react'
import { Col, Row, Input } from 'reactstrap'
import gql from 'graphql-tag'
import AddPricingModal from "./AddPricingModal"
import withApolloClient from '../withApolloClient'
import AdvancedFiltersControl from '../Filters/AdvancedFiltersControl'
import AppliedAdvancedFilters from '../Filters/AppliedAdvancedFilters'

const BulkUpdatePricingTemplateMutation = gql`
  mutation bulkUpdatePricingTemplate($input: BulkUpdatePricingTemplateMutationInput!) {
    bulkUpdatePricingTemplate(input: $input) {
      ok
      errors {
        messages
      }
    }
  }
`

class PricingListHeader extends Component {
    constructor(props) {
        super(props)
        this.state = {
            openModal: "",
        }
    }
    toggleModal = (modalName) => {
        this.setState({ openModal: this.state.openModal === modalName ? "" : modalName })
    }
    updateSearchTerm = (searchTerm) => {
        this.props.setFilterValues({ ...this.props.filterValues, searchTerm })
    }
    handleUpdatePricing = (name, value) => {
        let selectedPricing = this.props.selectedPricing
        let input = {
            pricingTemplates: selectedPricing,
            [name]: value
        }
        this.props.apolloClient
            .mutate({
                mutation: BulkUpdatePricingTemplateMutation,
                variables: { input },
            })
            .then((result) => {
                if (result.data && result.data.bulkUpdatePricingTemplate && result.data.bulkUpdatePricingTemplate.ok) {
                    this.props.refetchQuery()
                    this.props.resetSelectedPricing()
                }
            })
            .catch((err) => {
                this.setState({ loading: false, error: err.message })
            })
    }
    render() {
        return (
            <Row className="pb-2 align-items-center">
                {this.state.openModal === "addPricingModal" && <AddPricingModal isOpen={this.state.openModal === "addPricingModal"} toggleModal={() => this.toggleModal("addPricingModal")} refetch={() => this.props.refetchQuery()} />}
                <Col xs={4}>
                    <span className="driver-search-filter">
                        <Input type="text" name="searchTerm" placeholder="Search" onChange={(e) => this.updateSearchTerm(e.target.value)} />
                        <i className="fa fa-lg fa-search search-icon" aria-hidden="true"></i>
                    </span>
                </Col>
                <Col xs="auto" className="p-0">
                    <AdvancedFiltersControl entity="pricing_template" presets={this.props.presets} setPresets={this.props.setPresets} defaultPresets={this.props.defaultPresets} />
                </Col>
                <Col className="text-right">
                    {this.props.selectedPricing && this.props.selectedPricing.length > 0 && <>
                        <a id="viewFilters" className="driver-list-button" onClick={() => this.handleUpdatePricing("visibleToCustomers", false)}>
                            Not Visible To Customer | <i className="fa fa-eye-slash" aria-hidden="true"></i>
                        </a>&nbsp;&nbsp;&nbsp;&nbsp;
                        <a id="viewFilters" className="driver-list-button" onClick={() => this.handleUpdatePricing("visibleToCustomers", true)}>
                            Visible To Customer | <i className="fa fa-eye" aria-hidden="true"></i>
                        </a>&nbsp;&nbsp;&nbsp;&nbsp;
                        <a id="viewFilters" className="driver-list-button" onClick={() => this.handleUpdatePricing("isActive", false)}>
                            Set Inactive | <i className="fa fa-toggle-off" aria-hidden="true"></i>
                        </a>&nbsp;&nbsp;&nbsp;&nbsp;
                        <a id="viewFilters" className="driver-list-button" onClick={() => this.handleUpdatePricing("isActive", true)}>
                            Set Active | <i className="fa fa-toggle-on" aria-hidden="true"></i>
                        </a>&nbsp;&nbsp;&nbsp;&nbsp;
                    </>}

                    <a id="viewFilters" className="driver-list-button" onClick={() => this.toggleModal("addPricingModal")}>
                        Add New Price | <i className="fa fa-plus" aria-hidden="true"></i>
                    </a>
                </Col>
                <Col xs={12} className="mt-2 search-filter-container">
                    <AppliedAdvancedFilters
                        entity="pricing_template"
                        context={null}
                        presets={this.props.presets}
                        onPresetsChange={this.props.setPresets}
                    />
                </Col>
            </Row>
        )
    }
}


export default withApolloClient(PricingListHeader)
